import { atom, getDefaultStore, useAtomValue } from 'jotai';

const hasUserEverPaidAtom = atom<boolean>(false);

export const useHasUserEverPaid = (): boolean => useAtomValue(hasUserEverPaidAtom);
export const setHasUserEverPaid = (data: boolean): void => getDefaultStore().set(hasUserEverPaidAtom, data);
export const getHasUserEverPaid = (): boolean => getDefaultStore().get(hasUserEverPaidAtom);